import { styled } from "goober";
import { ClickButton } from "./ClickButton";
import { Link } from "./Link";

const itemStyles = `
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
  color: var(--text-primary);
  text-decoration: none;
  &:hover {
    background: var(--alpha4);
  }
`;

export const MenuItem = styled(ClickButton)`
  ${itemStyles}
  &:disabled {
    opacity: 0.5;
    cursor: default;
    &:hover {
      background: transparent;
    }
  }
`;

export const MenuItemLink = styled(Link)`
  ${itemStyles}
`;
